export { default as useUpdateQuery } from './useUpdateQuery';
